<template>
    <div class="chip chip-secondary has-delete" @click="toggle" :class="buttonStyles">
        <v-icon icon="circle" :class="colorClass"/>
        <span><slot/></span>
        <button class="btn btn-link">
            <v-icon :icon="visibilityIcon" :stop-propagation="true" @click="toggleVisibility"/><v-icon icon="close-s" :stop-propagation="true" @click="deactivateSegment"/>
        </button>
    </div>
</template>

<script>
    import vIcon from '@/components/form/v-icon';

    export default {
        name: 'segment-button',
        components: {vIcon},
        props: {
            label: {
                type: String,
                default: '',
            },
            segment: {
                type: Object,
                default: () => ({}),
            },
            editing: {
                type: Object,
                default: () => ({}),
            },
            index: {
                type: Number,
            },
        },
        computed: {
            buttonStyles() {
                return {
                    'is-selected': this.editing.id === this.segment.id,
                };
            },
            visibilityIcon() {
                return this.$store.getters['dashboard/isHidden'](this.segment.id) ? 'eye-closed' : 'eye';
            },
            colorClass() {
                const colors = ['icon-blue', 'icon-accent', 'icon-dark-background'];
                return colors[this.index];
            },
        },
        methods: {
            toggle() {
                this.$emit('click', this.segment.id);
            },
            toggleVisibility() {
                this.$emit('toggle-visiblity', this.segment.id);
            },
            deactivateSegment() {
                this.$emit('deactivate', this.segment.id);
            },
        },
    };
</script>
